import React from "react";
import Login from "../components/Login";

const LoginPage = () => {
  return (
    <section>
      <Login />
    </section>
  );
};

export default LoginPage;
